// ControlImageImportFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import RestService from 'RestService.js';

import ControlModel    from 'ControlModel.js';
import ImageImportControlView from 'advanced-inputs/ImageImportControlView.js';

//=============================================================================
//
// Creates an image import control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Maty Rocha, February 2016
//
//=============================================================================
class ControlImageImportFactory extends BaseVisualControlFactory {
    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.cornerRadius = 5;
        attributes.imageBackgroundText= '#FFFFFF';
        attributes.imageBackground= '#FFFFFF';
        attributes.buttonPositionAbove = 'false';
        attributes.borderColor = '#ABABAB';
        attributes.caption= 'Acquire';
        attributes.buttonLabelAcquire = 'Acquire';
        attributes.buttonLabelRemove = 'Remove';
        attributes.fileSize = RestService.getProfile().MaxAttachmentSize;
        attributes.maxSize = RestService.getProfile().MaxAttachmentSize;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.buttonTextColor ='~buttonTextColor';
        attributes.buttonFontFamily = '~buttonFont';
        attributes.buttonFontSize = '~buttonFont';
        attributes.buttonTextWeight = '~buttonFont';
        attributes.buttonTextStyle  = '~buttonFont';
        attributes.buttonBackgroundColor = '~buttonBgColor';
        attributes.buttonBackgroundGradientColor = '~buttonBgGradientColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.advancedBgGradientColor = '~buttonBgGradientColor';
        attributes.buttonBoldSelection = '';
        attributes.buttonItalicSelection = '';
        attributes.resizePadding = 2;
        attributes.imageBackgroundColor = '#FFFFFF';
		attributes.minWidth = 10;
		attributes.minHeight = 23;

        return new ImageImportControlView( { model: new ControlModel( attributes ), el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );
    }

}

const controlImageImportFactory = new ControlImageImportFactory();
export default controlImageImportFactory;
